import React, { useState } from "react";
import { Card } from "react-bootstrap";
import genericAvatar from "../../../assets/images/generic-avatar.jpeg";
import ModalDetailsVisiteur from "./ModalDetailsVisiteur";
import { ImMobile } from "react-icons/im";

const ComponentVisiteur = (props) => {
  const { visiteur, intervalle, haveMobile } = props;
  const [showDetails, setShowDetails] = useState(false);

  const handleShowDetails = () => {
    setShowDetails(true);
  };

  const handleCloseDetails = () => {
    setShowDetails(false);
  };

  return (
    <>
      <ModalDetailsVisiteur
        show={showDetails}
        handleClose={handleCloseDetails}
        logs={visiteur.logs}
        intervalle={intervalle}
      />
      <Card className="cardPersonne m-2 " border={"white"} onClick={handleShowDetails}>
        <div style={{ position: "relative" }}>
          {haveMobile ? (
            <div className="haveMobileVisiteur">
              <ImMobile size="1.5em" />
            </div>
          ) : (
            ""
          )}

          <Card.Img
            role="button"
            className="avatarVisiteur"
            variant="top"
            src={visiteur.profile_pic ? visiteur.profile_pic : genericAvatar}
          />
        </div>
        <Card.Body className="bodyPersonne">
          <Card.Text className="identite">
            {visiteur.prenom}
            <span className="fw-bold"> {visiteur.nom}</span>
          </Card.Text>
        </Card.Body>
      </Card>
    </>
  );
};

export default ComponentVisiteur;
